import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EventsPage } from '~/components/admin/events-page'
import { PageHeader } from '~/components/app-shell'

const text = (max: number) => z.string().max(max).catch('').default('')

export const Route = createFileRoute('/_authed/_admin/admin/events')({
  validateSearch: z.object({
    action: text(100),
    orgId: text(100),
    actor: text(100),
    from: text(10),
    to: text(10),
    cursor: text(100),
  }),
  head: () => ({ meta: [{ title: `${m.admin_nav_events()} – ${m.app_name()}` }] }),
  component: EventsRoute,
})

function EventsRoute() {
  const filter = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_nav_events()} description={m.admin_events_description()} />
      <EventsPage filter={filter} />
    </>
  )
}
